<p>help-shopify-identity-redirect works!</p>
